import React from "react";
//import { MDBBtn, MDBTable,  MDBTableBody, MDBTableHead, MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody } from "mdbreact";
//import SectionContainer from "../components/sectionContainer";
import axios from 'axios';
//import jsPDF from 'jspdf';
import 'jspdf-autotable';

//import {  MDBIcon } from 'mdbreact';

  ////////////////////////////////////////////////
  //Columnas para datos personales
  // const columnasdatospersonales = [
  // {
  //   label: "NOMBRES",
  //   field: "id",
  //   sort: "asc"
  // },
  // {
  //   label: "",
  //   field: "first",
  //   sort: "asc"
  // },
  // {
  //   label: "AFILIACION",
  //   field: "last",
  //   sort: "asc"
  // },
  // {
  //   label: "",
  //   field: "handle",
  //   sort: "asc"
  // },
  // {
  //   label: "VINCULO",
  //   field: "handle",
  //   sort: "asc"
  // },
  // {
  //   label: "",
  //   field: "handle",
  //   sort: "asc"
  // }
  // ] 

  ////////////////////////////////////////////////
  //Columnas para la boleta
  // const columnasBoleta = [    
  //   {
  //     label: "",
  //     field: "first",
  //     sort: "asc"
  //   },
  //   {
  //     label: "REMUNERACIONES",
  //     field: "last",
  //     sort: "asc"
  //   },
  //   {
  //     label: "",
  //     field: "handle",
  //     sort: "asc"
  //   },
  //   {
  //     label: "DESCUENTOS",
  //     field: "handle",
  //     sort: "asc"
  //   }    
  //   ] 

class DatatablePage extends React.Component{

  // getCount = v => {
  //   this.setState({ tipodeplanilla : v.target.value});     
  // };

  // //Evento del boton recuperar, el detalle de una boleta pagada
  // acceder(event){
  //   event.preventDefault();   
  //   //alert('Periodo : '+ this.periodoDato.value);   
  //   //alert('Tipo de planilla : '+ this.tipoDePlanillaDato.value);   
  //   //alert('hola'+ event.target.value);              
  //   //axios.get('http://10.10.5.58:8081/boletapdf/'+ this.state.usuario+'/122019/'+ this.state.tipodeplanilla+'/')

  //   axios.get('http://192.168.1.99:3001/boletapdf/'+ this.state.usuario+'/'+this.periodoDato.value +'/'+this.tipoDePlanillaDato.value+'/')
  //       .then((response) => this.setState({ boletapdf : response.data}))
  //       .catch()                                            
  // }

  // //Evento repetitivo del combo box de periodo
  // listarPlanillasPorPeriodo(event){
  //   event.preventDefault();   

  //   //alert('periodo elegido'+ event.target.value);  
  //   //alert('usuario : '+ this.state.usuario);  

  //   //axios.get('http://10.10.5.58:8081/boletapdf/'+ this.state.usuario+'/122019/'+ this.state.tipodeplanilla+'/')
  //   axios.get('http://192.168.1.99:3001/planillastrabajadorperiodo/'+event.target.value+'/'+this.state.usuario)
  //       .then((response) => this.setState({ planillasTrabajador : response.data}))
  //       .catch()                                            
  // }

  //Para recuperar en un archivo PDF

  // accederPDF(event){
  //   event.preventDefault();    

  //   axios.get('http://192.168.1.99:3001/boletapdf/'+ this.state.usuario+'/122019/'+ this.state.tipodeplanilla+'/')
  //       .then((response) => this.setState({ boletapdf : response.data}))
  //       .catch()                                                           
  //   var imgData = ''
              
  //       ////////////////////////////////////////////////////////        
  //       ////////////////////////////////////////////////////////        
  //       //CABECERA DE TABLA
  //         // function headRows() {
  //         //   return [{id: 'ID', name: 'Name', email: 'Email', city: 'City', expenses: 'Sum'}];
  //         // }
        
  //       ////////////////////////////////////////////////////////        
  //       ////////////////////////////////////////////////////////        
  //       //CUERPO DE TABLA
  //       //   function bodyRows(rowCount) {
  //       //     rowCount = rowCount || 10;
  //       //     let body = [];
  //       //     for (var j = 1; j <= rowCount; j++) {
  //       //         body.push({
  //       //             id: j,              
  //       //             name: 'nombre',
  //       //             email: 'email',
  //       //             city: 'ciudad',
  //       //             expenses: 'exoeriencia',
  //       //         });
  //       //     }
  //       //     return body;            
  //       // }        


  //       //var doc = new jsPDF('p', 'pt');
  //       var doc = new jsPDF();
  //       ////////////////////////////////////////////////////////        
  //       ////////////////////////////////////////////////////////        
  //       //Lineas de contorno
  //       //LInea horizontal superior        
  //       doc.line(13.7, 10, 196.3, 10);
  //       doc.setLineWidth(0.5);  

  //       //LInea horizontal inferior
  //       doc.line(13.7, 284, 196.3, 284);
  //       doc.setLineWidth(0.5);  
        
  //       //Linea lateral izquierda
  //       doc.line(13.7, 10, 13.7, 284);
  //       doc.setLineWidth(0.5);  

  //       //Linea lateral derecha
  //       doc.line(196.3, 10, 196.3, 284);
  //       doc.setLineWidth(0.5);        
        
  //       /////////////////////////////
  //       //LINEA MEDIA SUPERIOR
  //       //LInea horizontal inferior
  //       doc.line(13.7, 92, 196.3, 92);
  //       doc.setLineWidth(0.5);  

  //       doc.line(13.7, 108, 196.3, 108);
  //       doc.setLineWidth(0.5);  

  //       //LINEA MEDIA INFERIOR
  //       doc.line(13.7, 208, 196.3, 208);
  //       doc.setLineWidth(0.5);  

  //       doc.line(13.7, 210, 196.3, 210);
  //       doc.setLineWidth(0.5);  

  //       //LINEA DE PIE DE PAGINA
  //       doc.line(13.7, 280, 196.3, 280);
  //       doc.setLineWidth(0.5);  

  //       ////////////////////////////////////////////////////////        
  //       ////////////////////////////////////////////////////////        
  //       //Lineas centrales
  //       // doc.line(20, 350, 575, 350);
  //       // doc.setLineWidth(0.5);  
  //       // doc.line(20, 370, 575, 370);
  //       // doc.setLineWidth(0.5);  


  //       // doc.line(20, 550, 575, 550);
  //       // doc.setLineWidth(0.5);  
  //       // doc.line(20, 570, 575, 570);
  //       // doc.setLineWidth(0.5);  

  //       // doc.line(295, 350, 295, 570);
  //       // doc.setLineWidth(0.5);  
  //       ////////////////////////////////////////////////////////        
  //       ////////////////////////////////////////////////////////        
  //       ////////////////////////////////////////////////////////
  //       doc.setFont("times");
  //       doc.setFontStyle("normal");
  //       //Agregamos imagen               
  //       doc.addImage(imgData, 'JPEG', 115, 35, 40, 50);

  //        //TITULO 
  //       doc.setFontSize(16);
  //       doc.text('UNIVERSIDAD NACIONAL DE SAN ANTONIO ABAD DEL CUSCO', 20, 20);

  //       //SUB TITULO 
  //       doc.setFontSize(14);
  //       doc.text('EQUIPO DE REMUNERACIONES', 60, 25);

  //       //SUB SUB TITULO   
  //       doc.setFontSize(12);
  //       doc.text('BOLETA DE PAGO', 80, 30);

  //       ////////////////////////////////////////////////////////////
  //       /////////////////////////////////////////////////////////// TIPO DE PLANILLA
  //             ///CABECERA DATOS PERSONALES
  //             const cabeceraTipoPlanilla = [{periodo: 'PERIODO', nombrePlanilla: 'PLANILLA'}];

  //             ///DETALLE REMUNERACION
  //             var datosTipoPlanilla = [];

  //             //RECUPERAMOS LOS DATOS PERSONALES DEL TRABAJADOR
  //             let tipoplanillanombre;
  //             this.state.planillasTrabajador.map(element => {                          
  //               if (element.value===this.state.tipodeplanilla)                
  //                   tipoplanillanombre =  element.text;
  //             });                   
  //             //doc.setFontSize(12);
  //             //doc.text(tipoplanillanombre, 17, 97);                                                                  
  //             datosTipoPlanilla.push({"periodo":"   122019   ","nombrePlanilla":tipoplanillanombre});                      
              
  //             ///GENERAR TABLA TIPO DE PLANILLA
  //             doc.autoTable({                  
  //                 head: cabeceraTipoPlanilla, body: datosTipoPlanilla,
  //                 startY: 92,
  //                 theme: 'grid', 
  //                 showHead: 'firstPage',
  //                 headerStyles: {theme: 'grid'},
  //                 styles: {overflow: 'linebreak', columnWidth: '100', font: 'arial', fontSize: 7.5, cellPadding: 1, overflowColumns: 'linebreak'},  
  //                 columnStyles: { 0: {columnWidth: 20} },                 
  //                 //margin: {right: 107}
  //             });

  //       ////////////////////////////////////////////////////////////
  //       /////////////////////////////////////////////////////////// DATOS PERSONALES
  //             ///CABECERA DATOS PERSONALES
  //             const cabeceraDatosPersonales = [{nombre: 'NOMBRE', detalle: 'DETALLE'}];

  //             ///DETALLE REMUNERACION
  //             var datosDatosPersonales = [];

  //             //RECUPERAMOS LOS DATOS PERSONALES DEL TRABAJADOR
  //             let trabajador;
  //             let dni;
  //             let paterno;
  //             let materno;
  //             let nombres;
  //             let afp;

  //             this.state.datosPersonales.map(element => {                          
  //               if (element.descripcion==='Trabajador')                
  //                   trabajador =  element.nombre;
  //             });  
  //             this.state.datosPersonales.map(element => {                          
  //               if (element.descripcion==='Dni')                
  //                   dni =  element.nombre;
  //             });  
  //             this.state.datosPersonales.map(element => {                          
  //               if (element.descripcion==='Ap. Paterno')                
  //                   paterno =  element.nombre;
  //             });  
  //             this.state.datosPersonales.map(element => {                          
  //               if (element.descripcion==='Ap. Materno')                
  //                   materno =  element.nombre;
  //             }); 

  //             this.state.datosPersonales.map(element => {                          
  //               if (element.descripcion==='Nombres')                
  //                   nombres =  element.nombre;
  //             }); 

  //             this.state.datosPersonales.map(element => {                          
  //               if (element.afiliacion==='Afp')                
  //                   afp =  element.montoAfiliacion;
  //             });
                        
              
              
  //             datosDatosPersonales.push({"nombre":"NOMBRES","detalle":trabajador+' '+paterno+'-'+materno+'-'+nombres});          
  //             datosDatosPersonales.push({"nombre":"AFP","detalle":afp});                      
  //             //FIN RECUPERAR DATOS PERSONALES

  //             this.state.datosPersonales.map(element => {                          
  //               datosDatosPersonales.push({"nombre":element.item,"detalle":element.datos});          
  //             });                

  //             ///GENERAR TABLA DE REMUNERACION
  //             doc.autoTable({                  
  //                 head: cabeceraDatosPersonales, body: datosDatosPersonales,
  //                 startY: 35,
  //                 theme: 'grid', 
  //                 showHead: 'firstPage',
  //                 headerStyles: {theme: 'grid'},
  //                 styles: {overflow: 'linebreak', columnWidth: '100', font: 'arial', fontSize: 7.5, cellPadding: 1, overflowColumns: 'linebreak'},                  
  //                 margin: {right: 107}
  //             });

  //       ////////////////////////////////////////////////////////////
  //       /////////////////////////////////////////////////////////// REMUNERACION
  //             ///CABECERA REMUNERACION        
  //             const cabeceraRemuneracion = [{nomrem: 'REMUNERACION', monrem: 'MONTO'}];

  //             ///DETALLE REMUNERACION
  //             var datosRemuneracion = [];

  //             this.state.boletapdf.map(element => {          
  //               if (Number.isInteger(parseInt(element.monrem)))                    
  //                 datosRemuneracion.push({"nomrem":element.nomrem,"monrem":element.monrem});          
  //             });                

  //             ///GENERAR TABLA DE REMUNERACION
  //             let pageNumber = doc.internal.getNumberOfPages();

  //             doc.autoTable({                  
  //                 head: cabeceraRemuneracion, body: datosRemuneracion,
  //                 startY: 108,
  //                 showHead: 'firstPage',
  //                 styles: {overflow: 'linebreak', columnWidth: '100', font: 'arial', fontSize: 10, cellPadding: 1, overflowColumns: 'linebreak'},                  
  //                 columnStyles: { 1: {columnWidth: 16} },                                                              
  //                 //columnStyles: { 2: { halign: 'right'} },                                            
  //                 margin: {right: 107}
  //             });
      
  //       ////////////////////////////////////////////////////////////DESCUENTO
  //       ///////////////////////////////////////////////////////////  
  //                   ///CABECERA DESCUENTOS
  //                   const cabeceraDescuento = [{nomdes: 'DESCUENTO', mondes: 'MONTO'}];

  //                   ///DETALLE DESCUENTOS
  //                   var datosDescuento = [];
      
  //                   this.state.boletapdf.map(element => {          
  //                     if (Number.isInteger(parseInt(element.mondes)))                    
  //                         datosDescuento.push({"nomdes":element.nomdes,"mondes":element.mondes});          
  //                   });                
      
  //                 ///GENERAR TABLA DE DESCUENTOS
  //                 doc.setPage(pageNumber);                  

  //                 doc.autoTable({
  //                     head: cabeceraDescuento, body: datosDescuento,
  //                     startY: 108,
  //                     showHead: 'firstPage',
  //                     styles: {overflow: 'hidden'},
  //                     columnStyles: { 1: {rowHeight: 100}, 1: { halign: 'right'} },
  //                     margin: {left: 107}
  //                 });    
  //       ////////////////////////////////////////////////////////////
  //       /////////////////////////////////////////////////////////// RESUMENES
  //       let remuneracionTotal="0.00";
  //       let descuentoTotal="0.00";
  //       let neto="0.00";
  //       let aporte="0.00";
  //       //let tipoplanillanombre;
        
  //       // doc.setFont("times");
  //       // doc.setFontStyle("normal");
  //       doc.setFont("courier");        
  //       doc.setFontStyle("bolditalic");        
  //       //-------------------------------------------------------------------------------
  //       this.state.boletapdf.map(element => {                          
  //         if (element.monrem==='REMUNERACION TOTAL :')                
  //             remuneracionTotal =  element.nomdes;
  //       });           
  //       doc.setFontSize(10);
  //       doc.text('Remuneracion', 150, 80);
  //       doc.text(': ', 176, 80);
  //       doc.text(remuneracionTotal, 178, 80);        

  //       //-------------------------------------------------------------------------------
  //       this.state.boletapdf.map(element => {                          
  //         if (element.monrem==='DESCUENTO TOTAL:')                
  //             descuentoTotal =  element.nomdes;
  //       });           
  //       doc.setFontSize(10);

  //       doc.text('Descuento', 150, 84);
  //       doc.text(': ', 176, 84);
  //       doc.text(descuentoTotal, 178, 84);        

  //       //-------------------------------------------------------------------------------
  //       this.state.boletapdf.map(element => {                          
  //         if (element.monrem==='NETO :')                
  //             neto =  element.nomdes;
  //       });           
  //       doc.setFontSize(10);
  //       doc.text('Neto', 150, 88);
  //       doc.text(': ', 176, 88);
  //       doc.text(neto, 178, 88);
  //       //doc.text('Neto : '+neto, 135, 220);

  //       //-------------------------------------------------------------------------------
  //       this.state.boletapdf.map(element => {                          
  //         if (element.monrem==='APORTE :')                
  //              aporte =  element.nomdes;
  //       });           
  //       // doc.setFontSize(12);
  //       // doc.text('Aporte', 140, 225);
  //       // doc.text(': ', 172, 225);
  //       // doc.text(aporte, 175, 225);        

  //       //-------------------------------------------------------------------------------        
  //       ////////////////////////////////////////////////////////////
  //       /////////////////////////////////////////////////////////// RESUMENES NETOS DE LA PLANILLA
  //             ///CABECERA NETOS
  //             const cabeceraResumen = [{nombre: 'NOMBRE', detalle: 'DETALLE'}];

  //             ///DETALLE NETOS
  //             var datosResumen = [];              

  //             //RECUPERAMOS LOS DATOS PARA EL RESUMEN              
  //             datosResumen.push({"nombre":"Remuneracion","detalle":remuneracionTotal});                      
  //             datosResumen.push({"nombre":"Descuento","detalle":descuentoTotal});                      
  //             datosResumen.push({"nombre":"Neto","detalle":neto});                      
  //             datosResumen.push({"nombre":"Aporte","detalle":aporte});                      
              
  //             ///GENERAR TABLA TIPO DE PLANILLA
  //             doc.setPage(1);                  

  //             doc.autoTable({
  //                 head: cabeceraResumen, body: datosResumen,
  //                 startY: 210,                  
  //                 showHead: 'firstPage',
  //                 //theme: 'grid',       //sin fondo de color verde                              
  //                 //styles: {overflow: 'hidden'},                  
  //                 styles: {overflow: 'linebreak', columnWidth: '100', font: 'arial', fontSize: 10, cellPadding: 1, overflowColumns: 'linebreak',id: {DETALLE: "center"}},
  //                 columnStyles: { 1: { halign: 'right'} },                  
  //                 margin: {left: 150} //lugar donde inicia
  //                 // drawCell: function(cell, data) {
  //                 //   if (data.column.dataKey === 'DETALLE' ) {
  //                 //     cell.styles.halign = 'right';
  //                 //   }
  //                 // }
  //             }); 
                  
  //                 // headerStyles: {theme: 'grid'},
  //                 // styles: {overflow: 'linebreak', columnWidth: '100', font: 'arial', fontSize: 7.5, cellPadding: 1, overflowColumns: 'linebreak'},                  
        

  //       //PIE DE PAGINA,  MOSTRAR FECHA Y HORA DE IMPRESION
  //       var d = new Date();

  //       var dia=new Array(7);
  //           dia[0]="Domingo";
  //           dia[1]="Lunes";
  //           dia[2]="Martes";
  //           dia[3]="Miercoles";
  //           dia[4]="Jueves";
  //           dia[5]="Viernes";
  //           dia[6]="Sabado";

  //       var mes=new Array(12);  
  //           mes[0]="Enero";
  //           mes[1]="Febrero";
  //           mes[2]="Marzo";
  //           mes[3]="Abril";
  //           mes[4]="Mayo";
  //           mes[5]="Junio";
  //           mes[6]="Julio";
  //           mes[7]="Agosto";
  //           mes[8]="Septiembre";
  //           mes[9]="Octubre";
  //           mes[10]="Noviembre";
  //           mes[11]="Diciembre";

        
  //       doc.setFont("courier");
  //       doc.setFontStyle("bolditalic");
  //       doc.setFontSize(8);
  //       doc.text(dia[d.getDay()]+" "+d.getDate()+" de "+mes[d.getMonth()]+" del "+d.getFullYear()+" "+d.getHours()+":"+d.getMinutes()+":"+d.getSeconds(), 130, 283);                
  //       doc.text(dia[d.getDay()]+" "+d.getDate()+" de "+mes[d.getMonth()]+" del "+d.getFullYear()+" "+d.getHours()+":"+d.getMinutes()+":"+d.getSeconds(), 130, 33);                
  //       ////////////////////////////////////////////////////////////
  //       ///////////////////////////////////////////////////////////          
  //       ///GENERAR DOCUMENTOS FINAL
  //       doc.save('Generated.pdf')
  //     }
  //////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////
      closeCollapse = collapseID => () => {
        //Destruir sesion          
          axios.get('http://10.10.5.58:8081/borrarsesion/')    
              .then((response) => this.setState({ collapseID : ''}))
              .catch()                                           
        //Fin destruir sesion    
    
        window.scrollTo(0, 0);
        this.state.collapseID === collapseID && this.setState({ collapseID: '' });
      };

  // render(){
  //   //const { selects } = this.state;
  //   //<DocsLink title="Datatable" href="https://mdbootstrap.com/docs/react/tables/datatables/" />
  //   if(this.props.location.state && this.props.location.state.user){        
  //   } else {              
  //     window.location.href = "http://10.10.5.58:3000";      
  //   } 
  //   return(
  //     <MDBContainer className="mt-3">      
  //     <h1><strong>Equipo de remuneraciones</strong></h1>

  //     <MDBRow className="py-3">
  //       <MDBCol md="12">
  //         <SectionContainer title="Bienvenido :" noBorder>
  //           <MDBCard>
  //             <MDBCardBody>
  //             <MDBTable btn>
  //                 <MDBTableHead columns={columnasdatospersonales} />
  //                 <MDBTableBody rows={this.state.datosPersonales} />
  //               </MDBTable>
  //             </MDBCardBody>
  //           </MDBCard>
  //         </SectionContainer>
  //       </MDBCol>
  //     </MDBRow>

  //     <MDBRow className="py-3">

  //       <MDBCol md="12">          
  //         <SectionContainer className="text-center" header="" noBorder>                                         
  //         {/*combo box listado de cinco ultimos periodos*/}                              
  //         <MDBRow className="d-flex justify-content-left">   
  //             <h4 className="title">
  //               <MDBIcon icon="pencil-alt" /> Periodo :
  //             </h4>                            
  //               <MDBCol md="3">                
  //               <select
  //               className="browser-default custom-select mb-4"                                
  //               id="animationLoops"
  //               ref = {(input)=> this.periodoDato = input}
  //               onChange={this.listarPlanillasPorPeriodo.bind(this)}
  //               defaultValue={this.state.loop}
  //               >
  //                 {this.state.listadocincoultimosperiodos.map(select => (
  //                   <option key={select.periodo} value={select.periodo} >{select.detalle}</option>
  //                 ))}
  //               </select>
  //               </MDBCol>
  //           </MDBRow> 
  //         {/*fin  --  combo box listado de cinco ultimos periodos*/}    

  //         {/*combo box listado de planillas de trabajador en un periodo*/}    
  //           <MDBRow className="d-flex justify-content-left">              
  //           <h4 className="title">
  //               <MDBIcon icon="pencil-alt" /> Planilla :
  //           </h4>                            

  //               <MDBCol md="10">                
  //               <select
  //               className="browser-default custom-select mb-4"
  //               onChange={this.getCount}
  //               id="animationLoops"
  //               ref = {(input)=> this.tipoDePlanillaDato = input}
  //               defaultValue={this.state.loop}
  //               >
  //                 {this.state.planillasTrabajador.map(select => (
  //                   <option key={select.value} value={select.value} >{select.text}</option>
  //                 ))}
  //               </select>
  //               </MDBCol>                
  //           </MDBRow> 
  //         {/*combo box listado de planillas de trabajador en unperiodo*/}  

  //         {/*Boton recuperar*/}
  //           <MDBBtn outline color="primary" onClick={this.acceder.bind(this)}>
  //             Recuperar
  //           </MDBBtn> 
  //         {/*--Fin Boton recuperar*/}          
  //         </SectionContainer>
  //       </MDBCol>
  //     </MDBRow>

  //     <MDBRow className="py-3">
  //       <MDBCol md="12">
  //         <SectionContainer title="Boleta de pago"  noBorder>
  //           <MDBCard>
  //             <MDBCardBody>
  //             <MDBTable btn>
  //                 <MDBTableHead columns={columnasBoleta} />
  //                 <MDBTableBody rows={this.state.boletapdf} />
  //               </MDBTable>
  //             </MDBCardBody>
  //           </MDBCard>
  //           {/*Boton pdf*/}
  //           <MDBRow className="d-flex justify-content-center">  
  //             <MDBBtn outline color="primary" onClick={this.accederPDF.bind(this)}>
  //               Pdf
  //             </MDBBtn> 
  //           </MDBRow>              
  //         {/*--Fin Boton pdf*/}  
  //         </SectionContainer>
  //       </MDBCol>
  //     </MDBRow>
      
  //   </MDBContainer>
  //   )
  // }

  render(){
    return(
      <div>holaaa</div>
    );
  }

  state = {
    datosPersonales: [],  //se usa  
    listadocincoultimosperiodos: [],  //se usa  
    planillasTrabajador: [],
    boletapdf: [], //se usa
    tipodeplanilla : '', //se usa
    usuario : '',
    contador : '1',//al inicio no se dirige porque habra una carga
    collapseID: '',
    };
  
  async componentDidMount() {              
    const { user, user2 } = this.props.location.state    
    this.setState({ usuario : user })
    console.log(user);
    console.log(user2);

    Promise.all([
        await  fetch('http://192.168.1.99:3001/vinculopdf/'+user2),
        await  fetch('http://192.168.1.99:3001/cincoultimosperiodos/')     
    ])
    .then(([res1, res2]) => Promise.all([res1.json(), res2.json()]))
    .then(([data1, data2]) => this.setState({
        datosPersonales: data1,
        listadocincoultimosperiodos: data2
    }))
  }   
}
export default DatatablePage;
